import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { ApplicationSecurityService } from '../../../components/application-security/services/application-security.service';
interface IpAddressConfigurationModalContext {
  title: string;
  data: any;
}
@Component({
  selector: 'app-ip-address-configuration-modal',
  templateUrl: './ip-address-configuration-modal.component.html',
  styleUrls: ['./ip-address-configuration-modal.component.scss'],
})
export class IpAddressConfigurationModalComponent implements OnInit {
  pending: boolean = false;
  iPConfigurationForm: FormGroup = this.fb.group({
    response: ['', Validators.required],
  });
  formSubmitAttempt: boolean;
  error: null;
  success: null;
  data = this.modal.context.data;
  constructor(
    private appSecuritySvc: ApplicationSecurityService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IpAddressConfigurationModalContext, string, void>
  ) {}

  ngOnInit(): void {
    // this.document.body.classList.remove('panel');
  }

  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }

  isFieldValid(field: string) {
    return (
      (!this.iPConfigurationForm.get(field).valid &&
        this.iPConfigurationForm.get(field).touched) ||
      (this.iPConfigurationForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  nullify() {
    this.error = null;
    this.success = null;
  }

  save() {
    this.nullify();
    this.formSubmitAttempt = false;
    if (this.iPConfigurationForm.valid) {
      this.configureIpAdddress(this.iPConfigurationForm.value.response);
    }
  }

  configureIpAdddress(response: string): void {
    this.pending = true;
    this.appSecuritySvc
      .configureIpResponse({
        responseMessage: this.iPConfigurationForm.value.response,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.success =
            res && res.message ? res.message : 'Response changed successfully';
          setTimeout(() => {
            this.modal.approve('approved');
          }, 700);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  enableOnSave(item) {}
}

export class IpAddressConfigurationModal extends ComponentModalConfig<
  IpAddressConfigurationModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Tiny) {
    super(IpAddressConfigurationModalComponent, {
      title,
      data,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
